// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__X5Qsx","no-close":"_type_no-close__3Pujv"};